
export default {
    name: 'historique-grossesse',
    components: {},
    props: {
        historique: Object
    },
    data() {
        return {

        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {

    }
}